module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEVHcEwAseYAsOUAtOtmZmZtd3pmZmZmZmZoaGhmZmYAseZmZmYAr+UAsOUAseYAs+gAsOUAsOUAsOVnZ2dnZ2doaGhmZmYAr+R8ikpPAAAAF3RSTlMAa7IR4QzUf3bwPLrU7U8mw4mXZZ9G4E7g6kgAAACESURBVCjPvdJJDsMgDEBRA6WDmdOmvv9NayWKbEdk279CfoKFBcR0O5Vg6/2Bec/HHwGXnr0LZwgLbRVnIWQ6GgY8SVUBqjl1HsS0w9BAjeG+gzdQBfoV2Bso4PS8gEAsCoYCqDLPQYM81hsYgOb1qhTwvhDbcTagY5h/hjXxul6TvusPjLgRR0WW6IcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/download-unselect@2x.png
// module id = mFE+
// module chunks = 21